import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { useProfileStyles } from './styles';
import { priceFormatter } from '../../../../helpers/ProductHelper';
import RPGOLogoWhite from '../../../../assets/r_puntos_go_logo_white.svg';
import RPGO from '../../../common/icons/rpgo.svg';
import { POINTS_ROUTE } from '../../../../constants/Routes';

const ProfileRPGO = ({ ...props }) => {
  const { subscribed, totalPoints } = props;

  const classes = useProfileStyles();
  const rpgoUrl =
    'https://www.bancoripley.cl/formulario-cms/ripley-puntos/inscribete-en-ripley-puntos-go?utm_source=ripley-com&utm_medium=menu_rpgo&utm_campaign=inscribete_rpgo';

  return (
    <>
      {subscribed ? (
        <Link
          to={{
            pathname: POINTS_ROUTE,
          }}
          className={classes.link}
          data-cy="linkDetailMobile"
        >
          <Box display="flex" alignItems="center" justifyContent="center">
            Tienes
            <strong>&nbsp;{priceFormatter(totalPoints, '')}</strong>
            <img src={RPGO} className={classes.image} />
          </Box>
        </Link>
      ) : (
        <Box display="flex" flexDirection="row">
          <Button
            color="primary"
            disableElevation
            endIcon={<img src={RPGOLogoWhite} />}
            variant="contained"
            onClick={() => window.open(rpgoUrl, '_blank')}
            data-cy={'acceptTermsButtonProfile'}
            className={classes.buttonRPGO}
          >
            <span className={classes.acceptTermsText}>Acumular</span>
          </Button>
        </Box>
      )}
    </>
  );
};

ProfileRPGO.propTypes = {
  subscribed: PropTypes.bool,
  totalPoints: PropTypes.number,
};

export default ProfileRPGO;
